import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  key: 0,
  class: "red-color"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body scroll-y mx-5 mx-xl-15 my-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_FormComponent = _resolveComponent("FormComponent")!

  return (_ctx.getDynamicList)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "newCardModalRef",
        id: 'kt_modal_new_card_' + _ctx.routeKey,
        class: "modal dynamicEntityModal fade",
        tabindex: "-1",
        "aria-hidden": "true"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, [
                (_ctx.getMultipleFormEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Update " + _toDisplayString(_ctx.getPaginationTotalItems) + " records ", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.getFormName), 1))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_FormComponent, {
                id: "0",
                parentID: 0,
                routeKey: _ctx.getRouteKey
              }, null, 8, ["routeKey"])
            ])
          ])
        ])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}